<div class="verbatim-widget" [style.height]="height">
  <div class="verbatim-list" *ngIf="items.length > 0" (scroll)="onListScroll()">
    <div
      class="verbatim-item"
      *ngFor="let item of items; trackBy: trackByIndex"
      [ngClass]="'sentiment-' + item.sentiment"
      (mouseenter)="showHover($event, item)"
      (mouseleave)="hideHover()"
    >
      <span class="verbatim-item-text">{{ item.text }}</span>
    </div>
  </div>
  <div class="verbatim-empty" *ngIf="items.length === 0">No Data Available</div>
</div>
